export default "https://cdn-static.gokick.com/assets/5330764b9b84e4374a94f4eff9433164072ac9e6/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";